<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.addPackage") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #008274">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <ValidationObserver v-slot="{ invalid }">
        <form @submit.prevent="validateFormInputs()">
          <div class="row">
            <!-- name_ar -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.nameAr')"
              rules="required"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-input
                type="text"
                :col="12"
                @input="data.name_ar = allowArabicNumbersSymbols($event)"
                :placeholder="$t('PLACEHOLDERS.nameAr')"
                v-model.trim="data.name_ar"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>
            <!-- name_en -->

            <ValidationProvider
              :name="$t('PLACEHOLDERS.nameEn')"
              class="col-lg-6"
              rules="required"
              :col="12"
              v-slot="{ errors }"
            >
              <base-input
                :col="12"
                type="text"
                :placeholder="$t('PLACEHOLDERS.nameEn')"
                :errors="errors[0]"
                v-model.trim="data.name_en"
                @input="data.name_en = allowEnglishNumbersSymbols($event)"
                required
              />
            </ValidationProvider>
            <!-- descAr -->
            <ValidationProvider
              rules="arabicLettersAndNumbersOnly"
              class="col-lg-6"
              :name="$t('PLACEHOLDERS.descAr')"
              v-slot="{ errors }"
            >
              <base-input
                :col="12"
                :placeholder="$t('PLACEHOLDERS.descAr')"
                v-model="data.descAr"
                :errors="errors[0]"
                type="textarea"
              />
            </ValidationProvider>

            <!-- descEn -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.descEn')"
              rules="englishLettersAndNumbersOnly"
              class="col-lg-6"
              v-slot="{ errors }"
            >
              <base-input
                col="12"
                type="textarea"
                :placeholder="$t('PLACEHOLDERS.descEn')"
                v-model="data.descEn"
                :errors="errors[0]"
              />
            </ValidationProvider>

            <!-- price -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.price')"
              rules="required|decimal|positive"
              class="col-lg-6"
              v-slot="{ errors }"
            >
              <base-input
                col="12"
                type="number"
                :placeholder="$t('PLACEHOLDERS.price')"
                v-model.number="data.price"
                min="1"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>

            <!-- price_after_discount -->

            <ValidationProvider
              :name="$t('PLACEHOLDERS.price_after_discount')"
              v-slot="{ errors }"
              :rules="`decimal|price_after_discount:${data.price}`"
              class="col-lg-6"
            >
              <base-input
                col="12"
                type="number"
                :placeholder="$t('PLACEHOLDERS.price_after_discount')"
                v-model.number="data.price_after_discount"
                :errors="errors[0]"
                min="1"
              />
            </ValidationProvider>
            <!-- number_of_available_bids -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.number_of_available_bids')"
              rules="required|min_value:1|decimal"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-input
                col="12"
                type="number"
                :placeholder="$t('PLACEHOLDERS.number_of_available_bids')"
                v-model.number="data.number_of_available_bids"
                min="1"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>

            <!-- package_duration -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.package_duration')"
              rules="required|min_value:1"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-input
                col="12"
                type="number"
                :placeholder="$t('PLACEHOLDERS.package_duration')"
                v-model.number="data.package_duration"
                min="0"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>

            <!-- is_active -->
            <ValidationProvider
              rules="required"
              class="col-lg-6"
              v-slot="{ errors }"
              :name="$t('PLACEHOLDERS.status')"
            >
              <base-select-input
                col="12"
                :optionsList="statusOptions"
                :placeholder="$t('PLACEHOLDERS.status')"
                v-model="data.is_active"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>

            <!-- submit button -->
            <div class="btn_wrapper">
              <base-button
                :disabled="invalid"
                class="mt-2"
                styleType="primary_btn"
                :btnText="$t('BUTTONS.save')"
                :isLoading="isWaitingRequest"
              />
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import allowLanguageMinxin from "@/mixins/allowLanguageMinxins.js";

export default {
  name: "CreatePackage",
  mixins: [allowLanguageMinxin],
  watch: {},
  data() {
    return {
      isWaitingRequest: false,
      descArKey: 0,

      types: [],
      data: {
        color: "#F9F9F8",
        name_ar: "",
        name_en: "",
        descAr: null,
        descEn: null,
        price: null,
        type: null,
        price_after_discount: null,
        number_of_available_bids: null,
        package_duration: null,
        is_active: null,
      },
      statusOptions: [
        { id: 1, name: this.$t("STATUS.active"), value: 1 },
        { id: 0, name: this.$t("STATUS.notActive"), value: 0 },
      ],
    };
  },
  methods: {
    handleArabicInput(val) {
      this.data.descAr = this.allowArabicNumbersSymbols(val);
      // console.log(this.allowArabicNumbersSymbols(val));
    },
    handleEnglishInput(val) {
      this.data.descEn = this.allowEnglishNumbersSymbols(val);
    },
    async getTypes() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `estate-types?page=0&limit=0&status=1`,
        });
        this.types = res.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },
    async submitForm() {
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("name[ar]", this.data.name_ar ?? "");
      REQUEST_DATA.append("name[en]", this.data.name_en ?? "");
      REQUEST_DATA.append("description[ar]", this.data.descAr ?? "");
      REQUEST_DATA.append("description[en]", this.data.descEn ?? "");
      REQUEST_DATA.append("price", this.data.price);
      REQUEST_DATA.append("estate_type_id", this.data.type?.id);
      if (this.data.price_after_discount)
        REQUEST_DATA.append(
          "price_after_discount",
          this.data.price_after_discount
        );
      REQUEST_DATA.append("ads_number", this.data.number_of_available_bids);

      REQUEST_DATA.append("duration", this.data.package_duration);

      REQUEST_DATA.append("is_active", this.data.is_active?.value);

      try {
        await this.$axios({
          method: "POST",
          url: "packages",
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/packages/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
  },
  created() {
    this.getTypes();
  },
};
</script>
